export default {
    title: 'Notificações',
}